const initialState = {
    eventsByGroups: [],
    refDataEventProcess:[],
    refDataEventProcessOrders:[],
    gridOptions: {},
    rowData: []
};
export default initialState;